







































































































































































































































































































































































































































































import { Event } from '@/models/Event';
import app from '@/mixins/app';
import events from '@/mixins/events';
import calendar from '@/mixins/calendar';
import mixins from '@/utils/mixins';
import { isPlainObject } from 'lodash';
import { isArray } from '../../utils/helpers';
import moment from 'moment-timezone';

enum STEPS {
  Name = 1,
  Image = 2,
  Details = 3,
  Complete = 4
}
export default mixins(events, app, calendar).extend({
  data: () => ({
    dragging: false,
    analytics: false,
    step: STEPS.Name,
    column: 'google',
    eventName: 'eventName',
    eventNameRules: [
      (v: string) =>
        (v && v.length >= 9) || 'Name must be more than 8 characters'
    ],
    //interval
    interval: 0,
    value: 0,
    //interval
    itemsAdded: null,
    itemImage: null as any,
    cacheImage: null as string | null | File,

    // eventOptions: {}, //store state
    STEPS,
    dialog: false,
    loading: false,
    formTitle: 'Terms',
    validName: true,
    validImage: true,
    validAddress: true,
    eventData: {
      name: '',
      description: '',
      timezone: moment.tz.guess(),
      dates: [] as any[],
      logo: null as string | null | File,
      icon: null,
      address: {
        address1: '',
        address2: '',
        locality: '',
        region: '',
        postal_code: '',
        country: null
      },
      website: '',
      phone: '',
      email: '',
      social: {
        facebook: '',
        instagram: '',
        linkedin: '',
        twitter: '',
        youtube: ''
      }
    },
    defaultData: {
      name: '',
      description: '',
      timezone: moment.tz.guess(),
      dates: [] as any[],
      logo: null,
      icon: null,
      address: {
        address1: '',
        address2: '',
        locality: '',
        region: '',
        postal_code: '',
        country: null
      },
      website: '',
      phone: '',
      email: '',
      social: {
        facebook: '',
        instagram: '',
        linkedin: '',
        twitter: '',
        youtube: ''
      }
    },
    error: false
  }),
  methods: {
    close() {
      this.eventDialog = false;
      this.step = STEPS.Name;
      this.column = 'google';
      this.eventData = Object.assign({}, this.defaultData);
      this.value = 0;
      clearInterval(this.interval);
    },
    setForm(payload: any) {
      const data = new FormData();
      function iterate(payload: any) {
        for (const key in payload) {
          const value = payload[key];
          console.log({ key, value });

          if (isPlainObject(value)) {
            let keyName;
            for (const nestedKey in value) {
              keyName = [key, '.', nestedKey].join('');
              data.append(keyName, value[nestedKey]);
            }
          } else if (isArray(value)) {
            // for (const i = 0, valuePair; (valuePair = value[i]); i++)
            //   for (const j in valuePair)
            //     data.append([key, '[]', [j]].join(''), valuePair[j]);
            let keyName;
            for (let i = 0; i < value.length; i++) {
              keyName = [key, '[]', '[' + i + ']'].join('');
              if (isPlainObject(value[i])) {
                let keyName;
                for (const nestedKey in value[i]) {
                  keyName = [key, '[]', '[' + i + '].', nestedKey].join('');
                  data.append(keyName, value[i][nestedKey]);
                }
              } else {
                data.append(keyName, value[i]);
              }
            }
          } else if (value != null) {
            data.append(key, value);
          }
        }
      }
      iterate(payload);
      console.log(data.values);

      console.log(data.keys);

      return data;
    },
    async finishUp() {
      await this.close();
      this.$router.push({ name: 'getting-started' });
    },

    async create() {
      this.setImage();
      // TODO: formdata bug check
      // const data = this.setForm(this.eventData);
      await this.createEvent(this.eventData)
        .then((res: Event) => {
          console.log('SUCCESS');
          localStorage.setItem('current__event', res.id);
          this.createCalendar({
            event: res.id,
            name: `${res.name} Calendar`,
            description: `This is the calendar description for ${res.name}`,
            timezone: res.timezone
          });
        })
        .catch(() => {
          console.log('FAILED');
          this.error = true;
        })
        .finally(() => {
          this.interval = setInterval(() => {
            if (this.value > 100) {
              setTimeout(() => {
                clearInterval(this.interval);

                return (this.value = 100);
              }, 200);
            }
            this.value += 1;
          }, 100);
        });
    },
    eventStep() {
      switch (this.step) {
        case STEPS.Name:
          return this.step++;
        case STEPS.Image:
          return this.step++;
        case STEPS.Details:
          return this.step++;
        default:
          return this.step++;
      }
    },
    editMode() {
      this.loading = true;
      this.optionsEvent()
        .then(res => {
          console.log('RESULT', res);
        })
        .catch(() => {
          console.warn('ERROR FOUND');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    setImage() {
      this.eventData.logo = this.cacheImage;
    },

    onChange(e: any) {
      const reader = new FileReader();
      const files = e.target.files || e.dataTransfer.files;
      this.itemsAdded = files.length;
      reader.onload = (e: ProgressEvent<FileReader>) => {
        this.itemImage = e.target?.result;
      };
      reader.readAsDataURL(files[0]);
      this.cacheImage = files[0];
    },
    addDate() {
      this.eventData.dates.push({
        start: new Date(),
        end: new Date()
      });
    },
    verifyEventData(data: Event) {
      console.log('verified', data);
    },

    secondCardButtonAction() {
      switch (this.step) {
        case STEPS.Name:
          return this.eventStep();
        case STEPS.Image:
          return this.eventStep();
        case STEPS.Details:
          return this.eventStep();
        case STEPS.Complete:
          return this.eventStep();
        default:
          return this.eventStep();
      }
    }
  },
  computed: {
    currentTitle(): string {
      const stepState = `(Step ${this.step} of 4)`;
      switch (this.step) {
        case STEPS.Name:
          return stepState;
        case STEPS.Image:
          return stepState;
        case STEPS.Details:
          return stepState;
        case STEPS.Complete:
        default:
          return '(Final Step)';
      }
    },
    check(): boolean {
      switch (this.step) {
        case 1:
          if (this.eventName.length >= 9) {
            return false;
          }
          return true;
        case 2:
          return false;
        default:
          return false;
      }
    },
    checkEnd(): boolean {
      switch (this.step) {
        case 4:
          return this.analytics == true ? false : true;
        default:
          return false;
      }
    },
    continueBtn(): string {
      switch (this.step) {
        case 1:
          return 'Continue';
        case 2:
          return 'Continue';
        case 3:
          return 'Continue';
        case 4:
          return 'Create Event';
        default:
          return 'Create Event';
      }
    }
  },
  watch: {
    eventData: {
      handler(val) {
        console.log(val);
      },
      deep: true
    },
    eventDialog(val) {
      this.editMode(), val || this.close();
      console.log('Event Dialog', val);
    },
    step() {
      if (this.step === STEPS.Complete) {
        // push event data
      } else if (this.step === STEPS.Details) {
        if (!this.eventData.dates.length) {
          setTimeout(() => {
            this.addDate();
          }, 1000);
        }
      } else {
        // clearInterval(this.interval);
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  async mounted() {
    console.log('INITIALIZED CREATE EVRNT');
    console.log(this.$vuetify);
  }
});
